import Box from "@mui/material/Box"
import Stack from "@mui/material/Stack"
import { useEffect } from "react"

import TextInput from "@components/text_input"
import PhoneInput from "@components/text_input/sub_components/phone_input"

import { AccountPageContextProps } from "@contexts/account"
import { useAccountProfilePageContext } from "@contexts/account/profile"
import useTranslate from "@hooks/use_translate"
import styles from "./styles"

export default function AccountProfilePage() {
  const { translate, control, reset, me } = useAccountProfilePageContext()

  const { currentLanguage } = useTranslate()

  useEffect(() => {
    reset?.({
      firstName: me?.name as string,
      lastName: me?.surname as string,
      email: me?.email as string,
      language: currentLanguage || "",
      phone: {
        value: me?.phone ?? "",
        dialCode: me?.phone?.substring(0, 3),
        countryCode: "tr"
      }
    })
  }, [me, currentLanguage])

  return (
    <Stack sx={styles.containerWidth} gap={2} p={2}>
      <Stack gap={2}>
        <Stack direction={{ xs: "column", md: "row" }} spacing={1.5}>
          <TextInput<AccountPageContextProps["profileData"]>
            type="text"
            name="firstName"
            control={control}
            label={translate("first_name")}
            placeholder="Cemal"
            required
          />
          <TextInput<AccountPageContextProps["profileData"]>
            type="text"
            name="lastName"
            control={control}
            label={translate("last_name")}
            placeholder="Güneş"
            required
          />
        </Stack>
        <TextInput<AccountPageContextProps["profileData"]>
          type="email"
          name="email"
          control={control}
          label={translate("email")}
          placeholder="cemal@qpien.com"
          required
        />
        <Box>
          <PhoneInput<AccountPageContextProps["profileData"]>
            style={{ width: "800px" }}
            type="text"
            name="phone"
            control={control}
            label={translate("phone")}
            placeholder="1"
            required
          />
        </Box>
        <TextInput
          type="select"
          name="language"
          control={control}
          label={translate("language")}
          placeholder={translate("language")}
          selectOptions={[
            { label: "English", value: "en" },
            { label: "Türkçe", value: "tr" }
          ]}
        />
      </Stack>
    </Stack>
  )
}
